<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销报表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="产品编码">
                                <el-input
                                        v-model="q.proCode"
                                        placeholder="请输入"
                                        clearable>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="产品型号">
                                <el-input
                                        v-model="q.proModel"
                                        placeholder="请输入"
                                        clearable>
                                </el-input>
                            </el-form-item>
                            <!--<el-form-item label="库存状态">
                                <brselect
                                        category="kucun_status"
                                        :v="q.stockStatus"
                                        v-model="q.stockStatus"
                                        :multiple="true"
                                        collapseTags
                                        clearable>
                                </brselect>
                            </el-form-item>-->
                            <el-form-item label="创建人">
                                <el-input
                                        v-model="q.cuname"
                                        placeholder="请输入"
                                        clearable>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="预测单编号">
                                <el-input
                                        v-model="q.id"
                                        placeholder="请输入"
                                        clearable>
                                </el-input>
                            </el-form-item>
                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="库存状态">
                                        <brselect
                                                category="kucun_status"
                                                :v="q.stockStatus"
                                                v-model="q.stockStatus"
                                                :multiple="true"
                                                clearable>
                                        </brselect>
                                    </el-form-item>
                                    <el-form-item label="型号属性">
                                        <el-select v-model="q.protype"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="自产" value="自产"></el-option>
                                            <el-option label="OEM" value="OEM"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="区域">
                                        <brselectlazy placeholder="请选择"
                                                      category="dj_foreign_area"
                                                      :v="q.area"
                                                      v-model="q.area"
                                                      :multiple="true"
                                                      collapseTags
                                                      clearable>
                                        </brselectlazy>
                                    </el-form-item>
                                    <el-form-item label="国家名称">
                                        <brselectlazy placeholder="请选择"
                                                      category="YLCountry_agent"
                                                      :v="q.country"
                                                      v-model="q.country"
                                                      :multiple="true"
                                                      collapseTags
                                                      clearable>
                                        </brselectlazy>
                                    </el-form-item>

                                </div>
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="常规或改制">
                                        <brselect
                                                category="shifou_dingzhi"
                                                :v="q.isSpecific"
                                                v-model="q.isSpecific"
                                                clearable>
                                        </brselect>
                                    </el-form-item>
                                    <!--<el-form-item label="创建时间" class="timeselect" style="width: 50%;">
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="q.cdateBegin"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="q.cdateEnd"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>-->
                                  <!--  <el-form-item label="预测类型">
                                        <el-select v-model="q.ycrcode" clearable placeholder="请选择">
                                            <el-option
                                                    v-for="item in ycrlist"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>-->
                                    <el-form-item label="审核状态">
                                        <el-select v-model="forecastStatusArray" :multiple="true" clearable placeholder="请选择" @change="selectChanged" collapse-tags>
                                            <el-option v-for="item in forecastStatusList" :key="item.code"
                                                       :label="item.name" :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="发货状态">
                                        <el-select v-model="q.orderStatus"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="未发货" value="未发货"></el-option>
                                            <el-option label="部分发货" value="部分发货"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="　　是否需排产">
                                        <el-select v-model="q.isDel"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>

                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="是否生成采购">
                                        <el-select v-model="q.isCg"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!--
									<el-form-item label="是否需排产">
									    <el-select v-model="q.isDel"
									               placeholder="请选择"
									               clearable>
									        <el-option label="是" value="1"></el-option>
									        <el-option label="否" value="2"></el-option>
									    </el-select>
									</el-form-item> -->
                                    <el-form-item label="产品大类">
                                        <brselect
                                                category="product_level"
                                                :v="q.cpdlCode"
                                                v-model="q.cpdlCode"
                                                :multiple="true"
                                                collapseTags
                                                clearable>
                                        </brselect>
                                    </el-form-item>
                                    <el-form-item label="是否有可录单数量">
                                        <el-select v-model="q.haveUseNumber"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="使用预测订单号">
                                        <el-input
                                                v-model="q.orderSap"
                                                placeholder="请输入"
                                                clearable>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="占用订单编号">
                                        <el-input
                                                v-model="q.orderId"
                                                placeholder="请输入"
                                                clearable>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="型号经理是否审批">
                                        <el-select v-model="q.isXhsp"
                                                   placeholder="请选择"
                                                   clearable>
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>


                                  <el-form-item label="产地" >
                                    <brselect category="factory" :v="q.chandidata" :showcode="true"
                                              v-model="q.chandidata" :multiple="true" :collapse-tags="true" clearable></brselect>
                                  </el-form-item>

                                </div>
                            </div>
                        </el-collapse-transition>

                        <!-- 	<div class="h-formBtnOut h-columnCenter">
                                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                                <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                                <el-button  class="h-btn h-formBtn"
                                            @click="handleShoudongFilter"
                                            v-auth="'yuce_shoudong_guanbi'"
                                >手动处理</el-button>
                            </div> -->
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button  class="h-btn h-formBtn"
                                        @click="SDFilter"
                                        v-auth="'yuce_shoudong_guanbi'"
                            >手动处理</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn ljjinputpadding" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            @selection-change="handleSelectionChange"
                            stripe
                            :border="true"
                            max-height="460"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                fixed
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="id"
                                label="预测单编号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="area"
                                width="80"
                                :show-overflow-tooltip="true"
                                label="区域">
                            <template slot-scope="scope">
                                <dictname category="dj_foreign_area"  :v="scope.row.area"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                label="国家名称"
                                width="90"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
                                width="100"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                width="70"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                label="型号"
                                min-width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.proModel}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="100"
                                label="产品编码"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="forecastStatus"
                                label="预测状态"
                                width="80"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="yuce_zhuangt"  :v="scope.row.forecastStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="schedulingStatus"
                                label="排产状态"
                                width="80"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="isReformStock"
                                label="改制类型"
                                :show-overflow-tooltip="true"
                                width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isReformStock == 0">生产改制</span>
                                <span v-if="scope.row.isReformStock == 1">库存改制</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="isSpecific"
                                width="100"
                                label="常规或改制">
                            <template slot-scope="scope">
                                <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReq"
                                label="改制大类"
                                width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.specificReq}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReform"
                                label="改制要求"
                                width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.specificReform}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificRemark"
                                label="改制备注"
                                width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.specificRemark}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="数量"
                                width="60"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.proNumber}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="totalProduct"
                                label="排产数量"
                                width="80"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.totalProduct}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="useNumber"
                                label="可录单数量"
                                width="100"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span v-if="scope.row.forecastStatus == 3 || (scope.row.isSpecific == 2 && scope.row.isReformStock == '1' && scope.row.isXhsp == '1')">{{scope.row.useNumber}}</span>
                                <span v-else>0</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="useInventory"
                                width="100"
                                label="使用库存数量"
                                :show-overflow-tooltip="true">>
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.useInventory}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="scDateB"
                                label="生产时间"
                                width="100"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{scope.row.scDateB?scope.row.scDateB:'暂无数据'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="scDateE"
                                label="入库时间"
                                width="100"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{scope.row.scDateE?scope.row.scDateE:'暂无数据'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="warehouse"
                                label="库龄"
                                width="50"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.warehouse}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="stockStatus"
                                width="80"
                                label="库存状态">
                            <template slot-scope="scope">
                                <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cpdlCode"
                                label="产品大类"
                                width="80"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="product_level"  :v="scope.row.cpdlCode"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="protype"
                                label="型号属性"
                                width="80"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                label="产地"
                                width="80"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="deliveryMethod"
                                label="发货方式"
                                width="80"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span v-if="scope.row.deliveryMethod == 1">直发</span>
                                <span v-if="scope.row.deliveryMethod == 2">库发</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="passDate"
                                label="审批通过时间"
                                width="130"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="reformPriceRmb"
                                :show-overflow-tooltip="true"
                                width="120"
                                label="单台加价(元)">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.reformPriceRmb}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="preId"
                                label="预排单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="isReal"
                                label="是否实单"
                                width="90"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isReal == 1 ||scope.row.isReal == '1'">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="productId"
                                label="生产订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="totalFinish"
                                label="下线数量"
                                width="90"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.totalFinish}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                label="备注"
                                width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.remark}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="deliveryDate"
                                label="预计交货期"
                                width="110"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cgCode"
                                label="采购订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cgSapcode"
                                label="SAP采购订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="cgStatus"
                                label="采购订单状态"
                                width="120"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="cg_status"  :v="scope.row.cgStatus"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="orderId"
                                label="销售订单号"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="orderSap"
                                label="使用预测订单号"
                                width="140"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="orderStatus"
                                label="销售订单状态"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="shipmentNum"
                                label="销售订单发货数量"
                                width="150"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.shipmentNum}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="isXhsp"
                                :show-overflow-tooltip="true"
                                min-width="120"
                                label="型号经理是否审批">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isXhsp == 1">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                width="130"

                                label="操作">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    <el-tooltip content="查看占用" placement="top" @click.stop.prevent>
                                        <el-button type="primary" icon="el-icon-view" @click="showRow(scope.row.id)" size="mini" plain circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="跟踪审批" placement="top" @click.stop.prevent v-if="scope.row.spId && scope.row.spId != ''">
                                        <el-button type="primary" icon="el-icon-share"
                                                   @click="genzongLiuch2(scope.row)" size="mini" plain circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="释放库存" placement="top" @click.stop.prevent v-if="_user.usercode == scope.row.cucode" >
                                        <el-button type="primary" icon="el-icon-s-release"
                                                   @click="release(scope.row)" size="mini" plain circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="修改使用库存量" placement="top" @click.stop.prevent v-if="scope.row.cpdlCode == 'ND1' && yuceChangeNum">
                                        <el-button type="primary" icon="el-icon-edit-outline"
                                                   @click="openUseInventory(scope.row)" size="mini" plain circle></el-button>
                                    </el-tooltip>
                                    <br/>
                                    <!--预测单每周四17:30~24:00为冻结状态，无法修改和撤销 -->
                                    <el-tooltip content="修改" placement="top" @click.stop.prevent v-if="scope.row.showXG && !editLock">
                                        <el-button type="primary" icon="el-icon-edit"
                                                   @click="revise(scope.row)" size="mini" plain circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="撤单" placement="top" @click.stop.prevent v-if="scope.row.showXG && !editLock">
                                        <el-button type="primary" icon="el-icon-back"
                                                   @click="withdraw(scope.row)" size="mini" plain circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="修改" placement="top" @click.stop.prevent v-if="scope.row.showXG && editLock">
                                        <el-button type="primary" icon="el-icon-lock"
                                                   @click="editLockMsg(1)" size="mini" plain circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="撤单" placement="top" @click.stop.prevent v-if="scope.row.showXG && editLock">
                                        <el-button type="primary" icon="el-icon-lock"
                                                   @click="editLockMsg(2)" size="mini" plain circle></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="修改及撤单审批跟踪" placement="top" @click.stop.prevent v-if="(_user.usercode == scope.row.cucode || a == 1 || b == 1) && scope.row.instId">
                                        <el-button type="primary" icon="el-icon-guide"
                                                   @click="genzongLiuch(scope.row)" size="mini" plain circle></el-button>
                                    </el-tooltip>

                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" @click="createOrder" v-if="b == 1">创建采购订单</el-button>
                        </div>
                        <div class="h-pagination2 h-pageCenter">
                            <pagination :page="q" @query="handlelist"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <!--<el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>-->
               <!-- <el-button class="h-btn h-bBtn h-bgblueQ2" @click="reviseInventory" v-auth="'xgkc'">确定修改</el-button>-->
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>撤单</h1>
                        <p>Cancel Order</p>
                    </div>
                </div>
            </div>
            <div class="h-formLine h-mrb-38">
                <el-form :model="f" ref="f"
                         :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                    <el-form-item label="撤单描述" class="h-elformWrap-1">
                        <el-input v-model="f.describe" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel">取消</el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ2" @click="queren">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible2" class="h-dialog2 yonghu" @close="cancelRemark">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>备注</h1>
                        <p>Remark</p>
                    </div>
                </div>
            </div>
            <div class="h-formLine h-mrb-38">
                <el-form :model="sdremark" ref="sdremark"
                         :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                    <el-form-item label="处理备注" class="h-elformWrap-1">
                        <el-input v-model="sdremark.remark" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-formBtn h-bgwhite" @click="cancelRemark">取消</el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ2" @click="handleShoudongFilter">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible2" class="h-dialog2 yonghu" @close="cancelRemark">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>备注</h1>
                        <p>Remark</p>
                    </div>
                </div>
            </div>
            <div class="h-formLine h-mrb-38">
                <el-form :model="sdremark" ref="sdremark"
                         :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                    <el-form-item label="处理备注" class="h-elformWrap-1">
                        <el-input v-model="sdremark.remark" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-formBtn h-bgwhite" @click="cancelRemark">取消</el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ2" @click="handleShoudongFilter">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible3" class="h-dialog2 yonghu" @close="cancelUseInventory">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>修改使用库存量</h1>
                        <p>Adjust Use Inventory</p>
                    </div>
                </div>
            </div>
            <div class="h-formLine">
                <el-form :model="inventoryForm" ref="inventoryForm"
                         :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                    <el-form-item label="预测单编号" class="h-elformWrap-1">
                        <el-input v-model="inventoryForm.ycId" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="调整前数量" class="h-elformWrap-1">
                        <el-input v-model="inventoryForm.beforeNum" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="使用库存数量" class="h-elformWrap-1">
                        <el-input v-model="inventoryForm.afterNum" placeholder="请输入" @input="inputAfterNum"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="inventoryLogWrap">
                <div class="h-pieceInTitle3">
                    <h1>修改记录</h1>
                </div>
                <el-table
                    :data="inventoryLogList"
                    v-loading="inventoryLogLoading"
                    border
                    max-height="300"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        width="60"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        prop="beforeNum"
                        label="调整前数量"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="afterNum"
                        label="调整后数量"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="cuname"
                        label="操作人"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="cdate"
                        label="操作时间"
                        width="180"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-formBtn h-bgwhite" @click="cancelUseInventory">取消</el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ2" :loading="inventorySubmitting"
                           @click="submitUseInventory">确认
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                ycrlist: [{
                    value: 'my',
                    label: '我的预测'
                }, {
                    value: 'all',
                    label: '全部预测'
                }],
                yctype: [{
                    value: '2',
                    label: '待审核'
                }, {
                    value: '3',
                    label: '审核通过'
                }, {
                    value: '5',
                    label: '撤单审核中'
                }, {
                    value: '6',
                    label: '已撤单'
                }, {
                    value: '7',
                    label: '修改审核中'
                }],
                multipleSelection: [],
                tableData: [],
                userRole: [],
                inventoryli: [],
                // zcData:[],
                a: '',
                b: '',
                yuceChangeNum: false,
                loadFlag: '',
                timeValue1: '',
                timeValue2: '',
                instid: '',
                showhistory: false,
                q: {
                    idlist: [],
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    forecastStatus:'',
                    isDel: '',
                    flag: '1',
                    id: '',
                    country: '',
                    cdateBegin: '',
                    cdateEnd: '',
                    deliveryDateBegin: '',
                    deliveryDateEnd: '',
                    isSpecific: '',
                    lockStatus: '',
                    cpdlCode: '',
                    cuname: '',
                    proModel: '',
                    proCode: '',
                    ycrcode: '',
                    protype: '',
                    isCg: '',
                    orderStatus: '',
                    orderId: '',
                    orderSap: '',
                    stockStatus: '',
                    haveUseNumber:'',
                    isXhsp:'',

                },
                f:{
                    describe: ''
                },
                sdremark:{
                    remark: ''
                },
                en: {},
                dialogFormVisible:false,
                dialogFormVisible2:false,
                forecastStatusList:[],
                forecastStatusArray:[],
                //预测单修改锁状态
                editLock:false,
                //修改使用库存量弹窗
                dialogFormVisible3:false,
                inventorySubmitting:false,
                inventoryRow:{},
                inventoryForm:{
                    ycId: '',
                    beforeNum: '',
                    afterNum: ''
                },
                //使用库存量修改记录
                inventoryLogList: [],
                inventoryLogLoading: false,

            }
        },
        mounted() {
            this.query();
        },
        created() {

            if (this.$store.getters.hasRole('swyl_shengchan')) {
                this.q.isDel = '1';
                this.q.forecastStatus = '3';
            }
            //取消库存状态默认查询条件
            if (this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('swyl_waixiaogly') || this.$store.getters.hasRole('swyl_shengchan')) {
                this.a = 1;
              /*  this.q.stockStatus = '1';*/
            }
            if (this.$store.getters.hasRole('swyl_wxcggly') || this.$store.getters.hasRole('swyl_admin')) {
                this.b = 1;
            }

            if (this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('yuce_change_num')) {
                this.yuceChangeNum = true;
            }
            this.forecastStatusjiazai();

        },
        activated(){
            this.query();
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        methods: {
            addInventory(v) {
                if (this.inventoryli.length > 0) {
                    var ff = 0;
                    for (var i = 0; i < this.inventoryli.length; i++) {
                        if (v.id == this.inventoryli[i].id) {
                            ff++;
                        }
                    }
                    if (ff == 0) {
                        this.inventoryli.push(v);
                    }
                } else {
                    this.inventoryli.push(v);
                }

            },
            //撤单
            cancel(){
                this.f.describe = '';
                this.dialogFormVisible = false;
            },
            queren(){
                if (!this.f.describe || this.f.describe == '') {
                    this.$msg.msge("请输入撤单描述！");
                } else {
                    this.dialogFormVisible = false;
                    this.en.describe = this.f.describe
                    this.$msg.confirm("确认撤单?", () => {
                        console.log(this.en);
                        console.log(this.en.describe);
                        ss.waixiao.withdraw(this.en).then(rd => {
                            if (rd.f == true) {
                                this.$msg.msgs(rd.msg);
                            } else {
                                this.$msg.msge(rd.msg);
                            }
                            this.query();
                        })
                    })
                }
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            SDFilter() {
                if(this.multipleSelection.length == 0){
                    this.$msg.msge("至少选中一条操作！");
                    return false;
                }
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    if (this.multipleSelection[i].forecastStatus != 3) {
                        this.$msg.msge("请选择审核通过的数据！");
                        return false;
                    }
                }
                this.dialogFormVisible2 = true;
            },
            cancelRemark() {
                this.sdremark.remark = '';
                this.dialogFormVisible2 = false;
            },
            handleShoudongFilter(){
                if(this.multipleSelection.length == 0){
                    this.$msg.msge("至少选中一条操作！");
                    return false;
                }
                if (this.sdremark.remark == '') {
                    this.$msg.msge("请输入处理备注！");
                    return false;
                }

                var shlist = [];
                for(var i=0;i<this.multipleSelection.length;i++){
                    var obj = this.multipleSelection[i];
                    // shlist.push({id:obj.id});
                    shlist.push(obj.id);
                }
                shlist.push(this.sdremark.remark);
                console.log(shlist,"shoudong");
                var shoudongUpdate=shlist;
                var almsg = "该操作会设置库位为0，修改预测单为'已发货'，确认提交？";
                var wthis = this;
                this.$msg.cfm(almsg,"手动关闭预测单","确认","取消",()=>{
                    ss.waixiao.shoudongUpdate(shoudongUpdate).then(rd => {
                        wthis.$msg.alerts("修改成功，预测单已经转入已发货列表！");
                        this.sdremark.remark = '';
                        //将备注输入框关闭
                        this.dialogFormVisible2 = false;
                        wthis.query();
                    })
                })
            },
            genzongLiuch(v) {
                console.log(v.instId);
                this.instid = v.instId;
                this.showhistory = true;
            },
            genzongLiuch2(v) {
                console.log(v.spId);
                this.instid = v.spId;
                this.showhistory = true;
            },
            revise(v) {
                this.$msg.confirm("确认修改?", () => {
                    console.log(v);
                    if(v.isReformStock==1){
                        this.$msg.msge("库存改制单不允许修改！");
                        return;
                    }

                    ss.waixiao.checkRevise(v).then(rd => {
                        if (rd.f == true) {
                            this.$router.push({path: "/yuce/wxyuceRevise", query: {id: v.id}});
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                })
            },
            release(v){
                this.$msg.confirm("确定释放库存?", () => {
                    ss.waixiao.releaseById(v).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                        this.query();

                    })
                })

            },

            editLockMsg(flg){
                if(flg==1){
                    this.$msg.msge("周四下午17:30~24:00为锁定状态无法修改！");
                }else if(flg==2){
                    this.$msg.msge("周四下午17:30~24:00为锁定状态无法撤单！");
                }

            },
            withdraw(v) {
                this.dialogFormVisible = true;
                this.en = v;
            },
            reviseInventory() {
                this.$msg.confirm("确认修改?", () => {
                    if (!this.inventoryli || this.inventoryli.length == 0) {
                        this.$msg.msge("请修改使用库存数量后提交！");
                    } else if (this.inventoryli.length > 0) {
                        console.log(this.inventoryli,"都有什么");
                        ss.waixiao.reviseInventory(this.inventoryli).then(rd => {
                            if (rd.f == true) {
                                this.$msg.msgs(rd.msg);
                                this.inventoryli = [];
                                this.query();
                            } else {
                                this.$msg.msge(rd.msg);
                            }
                        }).catch(()=>{
                            this.inventoryli = [];
                            this.query();
                        })
                    }
                });
            },
            // createOrder(ycid) {
            //     this.$router.push({path: '/dingd/orderCreateYC', query: {ycId: ycid}});
            // },
            createOrder() {
                if (this.multipleSelection && this.multipleSelection.length > 0) {
                    var yc = [];
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        if (this.multipleSelection[i].protype == 'OEM' && this.multipleSelection[i].forecastStatus == 3) {
                            yc.push(this.multipleSelection[i].id);
                        } else if (this.multipleSelection[i].protype != 'OEM') {
                            this.$msg.msge("只有OEM产品才可创建采购订单！");
                            return false;
                        } else if (this.multipleSelection[i].forecastStatus != 3) {
                            this.$msg.msge("必须是审核通过的数据才可创建采购订单！");
                            return false;
                        }
                    }
                    var yd = [];
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        yd.push(this.multipleSelection[i].id);
                    }
                    ss.waixiao.isCreateCg(yd).then(rd => {
                        if (rd.f == false) {
                            this.$msg.msge(rd.msg);
                        } else {
                            this.$router.push('/dingd/orderCreateYC');
                            JSON.stringify(yc)
                            sessionStorage.setItem('ycId',yc);
                        }
                    })
                } else {
                    this.$msg.msg("请至少选择一条预测数据！");
                }
            },
            showRow(id) {
                this.$router.push({path: "/yuce/yuceOccupy", query: {id: id, status: 1}})
            },
            timeSelect1() {
                if (this.timeValue1) {
                    this.q.cdateBegin = this.timeValue1[0];
                    this.q.cdateEnd = this.timeValue1[1];
                } else {
                    this.q.cdateBegin = '';
                    this.q.cdateEnd = '';
                }
            },
            timeSelect2() {
                if (this.timeValue2) {
                    this.q.deliveryDateBegin = this.timeValue2[0];
                    this.q.deliveryDateEnd = this.timeValue2[1];
                } else {
                    this.q.deliveryDateBegin = '';
                    this.q.deliveryDateEnd = '';
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            resetData() {
                this.q.id = '';
                this.q.country = '';
                this.timeValue1 = '';
                this.q.cdateBegin = '';
                this.q.cdateEnd = '';
                this.timeValue2 = '';
                this.q.deliveryDateBegin = '';
                this.q.deliveryDateEnd = '';
                this.q.isSpecific = '';
                this.q.forecastStatus = '';
                this.q.lockStatus = '';
                this.q.cpdlCode = '';
                this.q.cuname = '';
                this.q.proModel = '';
                this.q.proCode = '';
                this.q.ycrcode = '';
                this.q.protype = '';
                this.q.isDel = '';
                this.q.isCg = '';
                this.q.orderStatus = '';
                this.q.orderId = '';
                this.q.orderSap = '';
                this.q.chandidata = '';
                if (this.a == 1) {
                    /*this.q.stockStatus = '1';*/
                } else {
                    this.q.stockStatus = '';
                }
                this.q.stockStatus = '';
                this.q.isXhsp = '';
                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.query();
            },
            //明细导出
            exportExcel() {
                this.q.idlist = [];
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach(element => {
                        this.q.idlist.push(element.id);
                    });
                }
                updownfile.down("/api/swyl/v1/demo/viewWxycReport/downloadreportExcel", this.q, "post", 'data');
            },
            query() {
                 //审核状态默认查询 2，3，5，7（待审核，审核通过，撤单审核中，修改审核中）
                if(this.q.forecastStatus==''){
                    this.q.forecastStatus='2,3,5,7';
                }
                ss.waixiao.showReportPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    if (this.tableData && this.tableData.length > 0) {
                        for (var i = 0; i < this.tableData.length; i++) {
                            this.tableData[i]['showXG'] = false;
                            this.tableData[i]['describe'] = '';
                            if (this._user.usercode == this.tableData[i].cucode && this.tableData[i].forecastStatus == 3) {
                                if (this.tableData[i].protype == '自产' && this.tableData[i].schedulingStatus != '已排产') {
                                    this.tableData[i].showXG = true;
                                }
                                if (this.tableData[i].protype == 'OEM' && (!this.tableData[i].cgCode || this.tableData[i].cgCode == '')) {
                                    this.tableData[i].showXG = true;
                                }
                            }
                        }
                    }
                })
                this.editLock = this.checkTime();

            },
            handleFilter() {
                this.q.pageNo = 1;
                console.log(this.q,"我看看");
                this.query();
            },
            handlelist() {
                this.query();
            },
            // gettabledata(xs){
            //     xs.forEach((item, index) => {
            //         ss.waixiao.selectAllPlan(item.id).then(rd => {
            //
            //             item.shengchanId = rd.aufnr;
            //             item.orderStatus = rd.orderStatus;
            //             item.finishTime = rd.gstrp;
            //         })
            //     })
            //     setTimeout(res=>{
            //         this.tableData = xs;
            //         console.log(this.tableData,"///////////////////");
            //     },1000)
            // },
            renovate() {
                this.$router.push({path: "/yuce/wxhuizong"});
            },
            handleTiaozhuan(){
                this.$router.push({path: "/yuce/wxhuizong1"});
            },

            //加载审核状态
            forecastStatusjiazai() {
                ss.Dictservice.listbycategory("report_zhuangt").then(rd => {
                    rd.forEach(obj => {
                        //只展示非已撤单的状态
                        if(obj.code!='6')
                        this.forecastStatusList.push(obj);
                    });
                })
            },
            selectChanged(value){
                this.q.forecastStatus=value.toString();
            },
            //检查当前日期是否是周四的下午5点半~23:59点之间
            checkTime(){
                var now = new Date();
                var year = now.getFullYear(); //获取当前年
                var mon = now.getMonth() + 1; //获取当前月
                var date = now.getDate(); //获取当前日
                var day = now.getDay();//获取当前日期 从星期天开始值为0
                 //判断是否为周四
                if(day==4){
                    let oStartDate = new Date(year+"-"+mon+"-"+date+" "+"17:30");
                    let oEndDate = new Date(year+"-"+mon+"-"+date+" "+"23:59");

                    if ((oEndDate.getTime() >= now.getTime()) && (oStartDate.getTime() <= now.getTime())) {
                        return true
                    }
                }
                return false;
            },

            //打开"修改使用库存量"弹窗
            openUseInventory(row) {
                this.inventoryRow = row;
                this.inventoryForm.ycId = row.id;
                this.inventoryForm.beforeNum = row.useInventory ? row.useInventory : 0;
                this.inventoryForm.afterNum = row.useInventory ? row.useInventory + '' : '';
                this.inventorySubmitting = false;
                this.queryUseInventoryLog();
                this.dialogFormVisible3 = true;
            },
            //查询使用库存量历史修改记录
            queryUseInventoryLog() {
                if (!this.inventoryRow || !this.inventoryRow.id) {
                    this.inventoryLogList = [];
                    return;
                }
                this.inventoryLogLoading = true;
                ss.waixiao.selectUseInventoryList({
                    ycId: this.inventoryRow.id
                }).then(rd => {
                    this.inventoryLogLoading = false;
                    if (rd && rd.records) {
                        this.inventoryLogList = rd.records;
                    } else if (rd && rd.list) {
                        this.inventoryLogList = rd.list;
                    } else {
                        this.inventoryLogList = rd || [];
                    }
                }).catch(() => {
                    this.inventoryLogLoading = false;
                    this.inventoryLogList = [];
                })
            },
            cancelUseInventory() {
                this.dialogFormVisible3 = false;
                this.inventoryRow = {};
                this.inventoryForm.ycId = '';
                this.inventoryForm.beforeNum = '';
                this.inventoryForm.afterNum = '';
                this.inventorySubmitting = false;
            },
            //使用库存数量只允许录入非负整数
            inputAfterNum(val) {
                this.inventoryForm.afterNum = (val ? val + '' : '').replace(/\D/g, '');
            },

            //提交使用库存数量调整
            submitUseInventory() {
                if (this.inventorySubmitting) {
                    return;
                }
                var afterStr = (this.inventoryForm.afterNum ? this.inventoryForm.afterNum + '' : '').replace(/\s/g, '');
                if (afterStr === '') {
                    this.$msg.msge("请输入使用库存数量！");
                    return;
                }
                var beforeNum = parseInt(this.inventoryForm.beforeNum ? this.inventoryForm.beforeNum : 0);
                var afterNum = parseInt(afterStr);
                var proNumber = parseInt(this.inventoryRow.proNumber ? this.inventoryRow.proNumber : 0);
                var useNumber = parseInt(this.inventoryRow.useNumber ? this.inventoryRow.useNumber : 0);
                if (afterNum + useNumber -beforeNum > proNumber) {
                    this.$msg.msge("使用库存数量+可录单数量不得大于预测数量！");
                    return;
                }
                if (afterNum === beforeNum) {
                    this.$msg.msge("使用库存数量未发生变化！");
                    return;
                }
                var params = {
                    ycId: this.inventoryRow.id,
                    beforeNum: beforeNum,
                    afterNum: afterNum
                };
                this.$msg.cfm("确认将使用库存数量由 " + beforeNum + " 修改为 " + afterNum + " ?", "修改使用库存量", "确认", "取消", () => {
                    this.inventorySubmitting = true;
                    ss.waixiao.adjustUseInventory(params).then(rd => {
                        this.inventorySubmitting = false;
                        this.$msg.msgs(rd && rd.msg ? rd.msg : "修改成功！");
                        this.dialogFormVisible3 = false;
                        this.query();
                    }).catch(() => {
                        this.inventorySubmitting = false;
                    })
                })
            },

        }
    }
</script>
<style>
    /* .ljjclassdate .el-date-editor .el-range-separator {
        width: 8%;
    } */
    .ljjtableinputa{
        margin-top: 0.03rem;
    }
    .ljjtableinputa .el-input__inner {
        padding: 0.01rem 0.1rem;
    }
    .ljjinputpadding .el-table tbody td .cell{
        padding: 0.05rem 0.1rem;
    }
    /* .h-formBorder .timeselect .el-form-item__content {
        line-height: 0.2rem;
    } */

    .h-formBorder .timeselect .el-date-editor .el-range-separator {
        width: 8%;
        line-height: 0.3rem;
    }

    .h-formBorder .timeselect .el-input__inner {
        padding-right: 0.1rem;
    }
    /*修改使用库存量弹窗-历史修改记录*/
    .inventoryLogWrap {
        padding: 0 0.28rem 0 0.25rem;

    }
    .inventoryLogWrap .h-pieceInTitle3 {
        margin-bottom: 0.12rem;
    }
</style>
